import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountBonusesComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    user: api.UserAccount;

    historyVisible: boolean = false;

    transfers: api.BonusTransfer[] = [];

    mounted() {
        this.loadModel();
    }

    loadModel() {
        this.$auth.getBonusStatus().then(
            (result: api.BonusStatus) => {
                if (result) {
                    this.transfers = result.transfers;
                }
            }
        );
    }

    onHistory() {
        this.historyVisible = !this.historyVisible;
    }
}
